// extracted by mini-css-extract-plugin
export default {"list__container":"RepositoriesList_list__container__KvZpc"};